import {ControlValueAccessor} from '@angular/forms';

/**
 * Mixin used for custom components in forms
 * @class
 * @implements {ControlValueAccessor}
 */
export class CustomFormControlValueAccessor implements ControlValueAccessor {
  /**
   * Data for the form
   */
  data: any;

  /**
   * writes the value on form control initiation
   * @param {any} obj value to write to the form control
   * @returns {void}
   */
  writeValue(obj: any): void {
    if (obj) {
      this.data = obj;
    }
  }

  /**
   * registers the onchange event with the form control
   * @param {any} fn function to propagate change
   * @returns {void}
   */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  /**
   * not used but required by the interface
   * @param {any} fn placeholder
   * @returns {void}
   */
  registerOnTouched(fn: any): void {
    // not needed
  }

  /**
   * captures and propagates the change
   * @param {any} event value from the inputs
   * @returns {void}
   */
  onChange(event: any): void {
    this.propagateChange(event);
  }

  /**
   * propagates the change to the form control
   * @returns {any}
   */
  propagateChange = (_: any): any => {
    // placeholder function used in core code
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/mixin/form/custom-form-control-value-accessor.ts